import React from 'react';
import { WarningBox, BodyText } from 'modules/styled';
import { useCommunity } from 'modules/community/community.selectors';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';

export const RATE_LIMIT = gql`
  query postRateLimit($postType: String!, $communityId: String!) {
    postRateLimit(postType: $postType, communityId: $communityId) {
      limit
      window
    }
  }
`;

RateLimitWarning.propTypes = {
  postType: PropTypes.string,
};

export function useRateLimit(postType) {
  const { _id, name } = useCommunity() || {};
  const { data } = useQuery(RATE_LIMIT, {
    fetchPolicy: 'no-cache',
    variables: {
      communityId: _id,
      postType,
    },
    skip: _id == null,
  });
  if (!data?.postRateLimit) return null;
  const { limit } = data?.postRateLimit;
  return limit ? { ...limit, community: name } : null;
}

export function RateLimitWarning({ postType, ...styleProps }) {
  const limit = useRateLimit(postType);
  if (!limit) return null;
  const text =
    postType === 'post'
      ? `You have reached your posting limit in ${limit.community} for the day. Your post will go directly to spam.`
      : `You have reached your comment limit for the day. Your comment will be hidden.`;
  return (
    <WarningBox {...styleProps}>
      <BodyText>{text}</BodyText>
    </WarningBox>
  );
}
